// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-flow-shell .invoice-catalogue-toggle {
  display: grid;
  width: 24px;
  height: 28px;
  flex: 0 0 24px;
  place-items: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.invoice-flow-shell .invoice-catalogue-toggle:hover {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.invoice-flow-shell .invoice-catalogue-toggle svg {
  width: 16px;
  height: 16px;
}
.invoice-flow-shell .invoice-rcti-row-actions {
  display: flex;
  grid-column: 6;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}
.invoice-flow-shell .invoice-rcti-row-actions button {
  display: grid;
  width: 32px;
  height: 40px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.invoice-flow-shell .invoice-rcti-row-actions button:hover:not(:disabled) {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.invoice-flow-shell .invoice-rcti-row-actions button:disabled {
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
}
.invoice-flow-shell .invoice-edit-item .quotation-item-result-card {
  width: 100%;
  border: 0;
  text-align: left;
  font-family: inherit;
}
.invoice-flow-shell .invoice-check-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 400;
}
.invoice-flow-shell .invoice-check-row input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--interactive-default, #0f766e);
}
.invoice-flow-shell .invoice-field-error {
  display: block;
  margin: 6px 0 0;
  color: var(--danger-text, #a3301f);
  font-size: 12px;
  line-height: 17px;
}
.invoice-flow-shell .invoice-document-list {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}
.invoice-flow-shell .invoice-document-row {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f6);
}
.invoice-flow-shell .invoice-document-row > div:first-child {
  display: grid;
  min-width: 0;
  gap: 4px;
}
.invoice-flow-shell .invoice-document-row strong {
  overflow: hidden;
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invoice-flow-shell .invoice-document-row small {
  color: var(--text-secondary, #506360);
  font-size: 11px;
}
.invoice-flow-shell .invoice-document-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}
.invoice-flow-shell .invoice-document-actions a,
.invoice-flow-shell .invoice-document-actions button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 12px var(--font-family-primary, "Lexend", sans-serif);
  text-decoration: none;
  cursor: pointer;
}
.invoice-flow-shell .invoice-document-actions a:hover,
.invoice-flow-shell .invoice-document-actions button:hover:not(:disabled) {
  border-color: var(--interactive-default, #0f766e);
  color: var(--interactive-default, #0f766e);
}
.invoice-flow-shell .invoice-document-actions button:disabled {
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
}
.invoice-flow-shell .invoice-document-actions svg {
  width: 14px;
  height: 14px;
}
.invoice-flow-shell.dark .invoice-document-row {
  border-color: var(--border-subtle, #30343a);
  background: var(--surface-secondary, #202226);
}
.invoice-flow-shell.dark .invoice-document-actions a,
.invoice-flow-shell.dark .invoice-document-actions button {
  border-color: var(--border-default, #3a3f47);
  background: var(--surface-primary, #191b1f);
  color: var(--text-primary, #f2f3f5);
}
.invoice-document-viewer-backdrop {
  position: fixed;
  z-index: 1400;
  inset: 0;
  display: grid;
  place-items: center;
  box-sizing: border-box;
  padding: 20px;
  background: rgba(15, 23, 22, 0.62);
}
.invoice-document-viewer {
  display: flex;
  width: min(100%, 1200px);
  max-height: 92vh;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);
}
.invoice-document-viewer > header,
.invoice-document-viewer > footer {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
}
.invoice-document-viewer > header {
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.invoice-document-viewer > header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}
.invoice-document-viewer > header button {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.invoice-document-viewer > header button:hover {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.invoice-document-viewer-content {
  min-height: 0;
  height: min(70vh, 760px);
  overflow: hidden;
}
.invoice-document-viewer-content img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.invoice-document-viewer-content iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
.invoice-document-viewer > footer {
  justify-content: flex-end;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.invoice-document-viewer > footer button {
  min-width: 88px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 13px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.invoice-flow-shell.dark .invoice-document-viewer {
  border-color: #343a3a;
  background: #191b1f;
  color: #f2f3f5;
}
.invoice-flow-shell.dark .invoice-document-viewer > header,
.invoice-flow-shell.dark .invoice-document-viewer > footer {
  border-color: #343a3a;
}
.invoice-flow-shell.dark .invoice-document-viewer > footer button {
  border-color: #3a3f47;
  background: #22252a;
  color: #f2f3f5;
}
.invoice-confirm-backdrop {
  position: fixed;
  z-index: 1400;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(15, 23, 22, 0.46);
}
.invoice-confirm-dialog {
  position: relative;
  width: min(100%, 440px);
  box-sizing: border-box;
  padding: 28px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  box-shadow: 0 16px 48px rgba(14, 26, 32, 0.2);
}
.invoice-confirm-dialog h2 {
  margin: 0 32px 8px 0;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
}
.invoice-confirm-dialog p {
  margin: 0 0 24px;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 21px;
}
.invoice-confirm-close {
  position: absolute;
  top: 14px;
  right: 14px;
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.invoice-confirm-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}
.invoice-confirm-actions button {
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 13px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.invoice-confirm-actions button.primary {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
}
.invoice-flow-shell.dark .invoice-confirm-actions button:not(.primary) {
  border-color: var(--border-default, #3a3f47);
  background: var(--surface-primary, #191b1f);
  color: var(--text-primary, #f2f3f5);
}
@media (max-width: 700px) {
  .invoice-flow-shell .invoice-rcti-row-actions {
    grid-column: 2;
    grid-row: 5;
  }
  .invoice-flow-shell .invoice-document-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
  .invoice-flow-shell .invoice-document-actions {
    width: 100%;
  }
  .invoice-flow-shell .invoice-document-actions a,
  .invoice-flow-shell .invoice-document-actions button {
    flex: 1 1;
  }
  .invoice-document-viewer-backdrop {
    padding: 12px;
  }
  .invoice-document-viewer {
    max-height: 96vh;
  }
  .invoice-document-viewer-content {
    height: 70vh;
  }
  .invoice-confirm-actions {
    display: grid;
    grid-template-columns: 1fr;
  }
  .invoice-confirm-actions button {
    width: 100%;
    min-height: 44px;
  }
}
.rcti-attachment-actions {
  display: flex;
  flex-shrink: 0;
  gap: var(--space-2, 8px);
}
.rcti-editor-shell .quotation-attachments-card > h2 {
  margin-bottom: var(--space-5, 20px);
}
.rcti-editor-shell .quotation-attachment-upload {
  flex-direction: row;
  margin: 0 !important;
}

/* RCTI uses the shared invoice fields; theme the control wrappers as well as inputs. */
.rcti-editor-shell.dark
  :is(.quotation-input-box, .quotation-item-search-box, .quotation-select-box, .invoice-themed-select, .figma-datepicker__input-container, .quotation-figma-dropdown-trigger, .quotation-figma-dropdown-menu) {
  color: var(--text-primary);
  background: var(--surface-primary);
  border-color: var(--border-default);
  color-scheme: dark;
}
.rcti-editor-shell.dark :is(input, textarea, select) {
  color: var(--text-primary);
  background: var(--surface-primary);
  border-color: var(--border-default);
  color-scheme: dark;
}
.rcti-editor-shell.dark :is(input, textarea)::placeholder {
  color: var(--text-tertiary);
  opacity: 1;
}
.rcti-editor-shell.dark :is(input, textarea, select):disabled {
  color: var(--text-disabled);
  background: var(--surface-secondary);
}
.rcti-adjustment-card {
  margin-bottom: 20px;
}
.rcti-adjustment-card > textarea {
  display: block;
  width: 100%;
  min-height: 80px;
  margin-top: 8px;
  padding: 12px;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: inherit;
}
.rcti-previous-version {
  padding: 12px 0;
  border-top: 1px solid var(--border-subtle);
}
.rcti-previous-version h3 {
  margin: 0 0 10px;
  color: var(--text-primary);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
}
.rcti-editor-shell.dark
  :is(.invoice-flow-card label, .invoice-flow-card h2, .invoice-editor-header
    h1) {
  color: var(--text-primary);
}
.rcti-editor-shell.dark
  :is(.invoice-flow-card > p, .invoice-editor-intro, .invoice-editor-header
    > div
    > p) {
  color: var(--text-secondary);
}

.rcti-editor-shell.dark .invoice-item-actions > button {
  background: var(--surface-primary);
  border-color: var(--border-default);
  color: var(--text-primary);
}
.rcti-editor-shell.dark .invoice-item-actions > button:hover:not(:disabled) {
  background: var(--interactive-soft-hover);
  border-color: var(--interactive-hover);
}
.rcti-editor-shell.dark .invoice-item-actions > button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.rcti-editor-shell.dark .invoice-item-actions > button:disabled {
  background: var(--surface-secondary);
  border-color: var(--border-subtle);
  color: var(--text-disabled);
  cursor: not-allowed;
}

.rcti-editor-shell.dark .invoice-attachment-box {
  background: var(--surface-secondary);
  border-color: var(--border-subtle);
  color: var(--text-primary);
}
.rcti-editor-shell.dark .invoice-attachment-box strong {
  color: var(--text-primary);
}
.rcti-editor-shell.dark .invoice-attachment-box p {
  color: var(--text-secondary);
}

.rcti-editor-shell.dark .invoice-item-heading {
  background: var(--surface-secondary);
  color: var(--text-primary);
}
.rcti-editor-shell.dark .invoice-section-title p,
.rcti-editor-shell.dark .invoice-flow-card > small {
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,+DAA+D;EAC/D,qBAAqB;EACrB,eAAe;AACjB;AACA;;EAEE,iDAAiD;EACjD,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;AACA;;EAEE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,2CAA2C;AAC7C;AACA;;EAEE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,mDAAmD;AACrD;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,+DAA+D;EAC/D,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,6CAA6C;AAC/C;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,+DAA+D;EAC/D,eAAe;AACjB;AACA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;AACA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;;IAEE,SAAO;EACT;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,uFAAuF;AACvF;;EAEE,0BAA0B;EAC1B,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;EACnC,sCAAsC;AACxC;AACA;;;EAGE,0BAA0B;AAC5B;AACA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;;EAEE,4BAA4B;AAC9B","sourcesContent":[".invoice-flow-shell .invoice-catalogue-toggle {\n  display: grid;\n  width: 24px;\n  height: 28px;\n  flex: 0 0 24px;\n  place-items: center;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.invoice-flow-shell .invoice-catalogue-toggle:hover {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-flow-shell .invoice-catalogue-toggle svg {\n  width: 16px;\n  height: 16px;\n}\n.invoice-flow-shell .invoice-rcti-row-actions {\n  display: flex;\n  grid-column: 6;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n}\n.invoice-flow-shell .invoice-rcti-row-actions button {\n  display: grid;\n  width: 32px;\n  height: 40px;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.invoice-flow-shell .invoice-rcti-row-actions button:hover:not(:disabled) {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-flow-shell .invoice-rcti-row-actions button:disabled {\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n}\n.invoice-flow-shell .invoice-edit-item .quotation-item-result-card {\n  width: 100%;\n  border: 0;\n  text-align: left;\n  font-family: inherit;\n}\n.invoice-flow-shell .invoice-check-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 16px;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 400;\n}\n.invoice-flow-shell .invoice-check-row input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--interactive-default, #0f766e);\n}\n.invoice-flow-shell .invoice-field-error {\n  display: block;\n  margin: 6px 0 0;\n  color: var(--danger-text, #a3301f);\n  font-size: 12px;\n  line-height: 17px;\n}\n.invoice-flow-shell .invoice-document-list {\n  display: grid;\n  gap: 8px;\n  margin-top: 12px;\n}\n.invoice-flow-shell .invoice-document-row {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 14px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f6);\n}\n.invoice-flow-shell .invoice-document-row > div:first-child {\n  display: grid;\n  min-width: 0;\n  gap: 4px;\n}\n.invoice-flow-shell .invoice-document-row strong {\n  overflow: hidden;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 500;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.invoice-flow-shell .invoice-document-row small {\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n}\n.invoice-flow-shell .invoice-document-actions {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 8px;\n}\n.invoice-flow-shell .invoice-document-actions a,\n.invoice-flow-shell .invoice-document-actions button {\n  display: inline-flex;\n  min-height: 34px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 12px var(--font-family-primary, \"Lexend\", sans-serif);\n  text-decoration: none;\n  cursor: pointer;\n}\n.invoice-flow-shell .invoice-document-actions a:hover,\n.invoice-flow-shell .invoice-document-actions button:hover:not(:disabled) {\n  border-color: var(--interactive-default, #0f766e);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-flow-shell .invoice-document-actions button:disabled {\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n}\n.invoice-flow-shell .invoice-document-actions svg {\n  width: 14px;\n  height: 14px;\n}\n.invoice-flow-shell.dark .invoice-document-row {\n  border-color: var(--border-subtle, #30343a);\n  background: var(--surface-secondary, #202226);\n}\n.invoice-flow-shell.dark .invoice-document-actions a,\n.invoice-flow-shell.dark .invoice-document-actions button {\n  border-color: var(--border-default, #3a3f47);\n  background: var(--surface-primary, #191b1f);\n  color: var(--text-primary, #f2f3f5);\n}\n.invoice-document-viewer-backdrop {\n  position: fixed;\n  z-index: 1400;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  box-sizing: border-box;\n  padding: 20px;\n  background: rgba(15, 23, 22, 0.62);\n}\n.invoice-document-viewer {\n  display: flex;\n  width: min(100%, 1200px);\n  max-height: 92vh;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);\n}\n.invoice-document-viewer > header,\n.invoice-document-viewer > footer {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 18px;\n}\n.invoice-document-viewer > header {\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.invoice-document-viewer > header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n}\n.invoice-document-viewer > header button {\n  display: grid;\n  width: 36px;\n  height: 36px;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.invoice-document-viewer > header button:hover {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-document-viewer-content {\n  min-height: 0;\n  height: min(70vh, 760px);\n  overflow: hidden;\n}\n.invoice-document-viewer-content img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.invoice-document-viewer-content iframe {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.invoice-document-viewer > footer {\n  justify-content: flex-end;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.invoice-document-viewer > footer button {\n  min-width: 88px;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 13px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.invoice-flow-shell.dark .invoice-document-viewer {\n  border-color: #343a3a;\n  background: #191b1f;\n  color: #f2f3f5;\n}\n.invoice-flow-shell.dark .invoice-document-viewer > header,\n.invoice-flow-shell.dark .invoice-document-viewer > footer {\n  border-color: #343a3a;\n}\n.invoice-flow-shell.dark .invoice-document-viewer > footer button {\n  border-color: #3a3f47;\n  background: #22252a;\n  color: #f2f3f5;\n}\n.invoice-confirm-backdrop {\n  position: fixed;\n  z-index: 1400;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  background: rgba(15, 23, 22, 0.46);\n}\n.invoice-confirm-dialog {\n  position: relative;\n  width: min(100%, 440px);\n  box-sizing: border-box;\n  padding: 28px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  box-shadow: 0 16px 48px rgba(14, 26, 32, 0.2);\n}\n.invoice-confirm-dialog h2 {\n  margin: 0 32px 8px 0;\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 600;\n}\n.invoice-confirm-dialog p {\n  margin: 0 0 24px;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 21px;\n}\n.invoice-confirm-close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  display: grid;\n  width: 36px;\n  height: 36px;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.invoice-confirm-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.invoice-confirm-actions button {\n  min-height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 13px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.invoice-confirm-actions button.primary {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n}\n.invoice-flow-shell.dark .invoice-confirm-actions button:not(.primary) {\n  border-color: var(--border-default, #3a3f47);\n  background: var(--surface-primary, #191b1f);\n  color: var(--text-primary, #f2f3f5);\n}\n@media (max-width: 700px) {\n  .invoice-flow-shell .invoice-rcti-row-actions {\n    grid-column: 2;\n    grid-row: 5;\n  }\n  .invoice-flow-shell .invoice-document-row {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 10px;\n  }\n  .invoice-flow-shell .invoice-document-actions {\n    width: 100%;\n  }\n  .invoice-flow-shell .invoice-document-actions a,\n  .invoice-flow-shell .invoice-document-actions button {\n    flex: 1;\n  }\n  .invoice-document-viewer-backdrop {\n    padding: 12px;\n  }\n  .invoice-document-viewer {\n    max-height: 96vh;\n  }\n  .invoice-document-viewer-content {\n    height: 70vh;\n  }\n  .invoice-confirm-actions {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n  .invoice-confirm-actions button {\n    width: 100%;\n    min-height: 44px;\n  }\n}\n.rcti-attachment-actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: var(--space-2, 8px);\n}\n.rcti-editor-shell .quotation-attachments-card > h2 {\n  margin-bottom: var(--space-5, 20px);\n}\n.rcti-editor-shell .quotation-attachment-upload {\n  flex-direction: row;\n  margin: 0 !important;\n}\n\n/* RCTI uses the shared invoice fields; theme the control wrappers as well as inputs. */\n.rcti-editor-shell.dark\n  :is(.quotation-input-box, .quotation-item-search-box, .quotation-select-box, .invoice-themed-select, .figma-datepicker__input-container, .quotation-figma-dropdown-trigger, .quotation-figma-dropdown-menu) {\n  color: var(--text-primary);\n  background: var(--surface-primary);\n  border-color: var(--border-default);\n  color-scheme: dark;\n}\n.rcti-editor-shell.dark :is(input, textarea, select) {\n  color: var(--text-primary);\n  background: var(--surface-primary);\n  border-color: var(--border-default);\n  color-scheme: dark;\n}\n.rcti-editor-shell.dark :is(input, textarea)::placeholder {\n  color: var(--text-tertiary);\n  opacity: 1;\n}\n.rcti-editor-shell.dark :is(input, textarea, select):disabled {\n  color: var(--text-disabled);\n  background: var(--surface-secondary);\n}\n.rcti-adjustment-card {\n  margin-bottom: 20px;\n}\n.rcti-adjustment-card > textarea {\n  display: block;\n  width: 100%;\n  min-height: 80px;\n  margin-top: 8px;\n  padding: 12px;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: inherit;\n}\n.rcti-previous-version {\n  padding: 12px 0;\n  border-top: 1px solid var(--border-subtle);\n}\n.rcti-previous-version h3 {\n  margin: 0 0 10px;\n  color: var(--text-primary);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-editor-shell.dark\n  :is(.invoice-flow-card label, .invoice-flow-card h2, .invoice-editor-header\n    h1) {\n  color: var(--text-primary);\n}\n.rcti-editor-shell.dark\n  :is(.invoice-flow-card > p, .invoice-editor-intro, .invoice-editor-header\n    > div\n    > p) {\n  color: var(--text-secondary);\n}\n\n.rcti-editor-shell.dark .invoice-item-actions > button {\n  background: var(--surface-primary);\n  border-color: var(--border-default);\n  color: var(--text-primary);\n}\n.rcti-editor-shell.dark .invoice-item-actions > button:hover:not(:disabled) {\n  background: var(--interactive-soft-hover);\n  border-color: var(--interactive-hover);\n}\n.rcti-editor-shell.dark .invoice-item-actions > button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.rcti-editor-shell.dark .invoice-item-actions > button:disabled {\n  background: var(--surface-secondary);\n  border-color: var(--border-subtle);\n  color: var(--text-disabled);\n  cursor: not-allowed;\n}\n\n.rcti-editor-shell.dark .invoice-attachment-box {\n  background: var(--surface-secondary);\n  border-color: var(--border-subtle);\n  color: var(--text-primary);\n}\n.rcti-editor-shell.dark .invoice-attachment-box strong {\n  color: var(--text-primary);\n}\n.rcti-editor-shell.dark .invoice-attachment-box p {\n  color: var(--text-secondary);\n}\n\n.rcti-editor-shell.dark .invoice-item-heading {\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n}\n.rcti-editor-shell.dark .invoice-section-title p,\n.rcti-editor-shell.dark .invoice-flow-card > small {\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
